import wx from 'weixin-js-sdk'
import ua from '@/utils/ua'
import wechat from '@/api/wechat'
import { saveWechatRegisterURL, getWechatRegisterURL } from '@/utils/helper'
import sha1 from 'sha1'

const defaultShareConfig = {
  imgUrl: 'https://wz-s1.makingdreams101.cn/wanzhuan_mp/share/lottery-h5-shareImage.png',
  title: '领取福利彩券票，赢千万大奖',
  desc: '',
  link: 'https://h5-test.globuyx.com/lottery/shop'
}

const jsApiList = [
  'checkJsApi',
  'chooseImage',
  'scanQRCode',
  'previewImage',
  'getLocalImgData',
  'updateAppMessageShareData',
  'onMenuShareQQ',
  'onMenuShareWeibo',
  'onMenuShareQZone',
  'chooseWXPay'
]

const preInovkeApiList = [
  'onMenuShareQQ',
  'onMenuShareWeibo',
  'onMenuShareQZone',
  'updateAppMessageShareData'
]

let isGetTicket = false

saveWechatRegisterURL()
class Wechat {
  constructor() {
    if (isGetTicket && ua.isIOS) {
      return this
    }

    // this.getTicket()
  }
  init(config) {
    config = this.getShareConfig(config)

    console.log('config', config)

    return new Promise(resolve => {
      if (isGetTicket && ua.isIOS) {
        resolve(wx)
      }

      wx.ready(() => {
        resolve(wx)

        preInovkeApiList.forEach(api => {
          wx[api](config)
        })
      })

      wx.error(error => {
        console.log('error', error)
        // this.getTicket()
      })
    })
      .catch(error => {
        console.log('error', error)
      })
      .finally(() => {
        console.log('finally')
      })
  }
  getShareConfig(shareConfig = {}) {
    return {
      imgUrl: shareConfig.imgUrl || defaultShareConfig.imgUrl,
      title: shareConfig.title || defaultShareConfig.title,
      desc: shareConfig.desc || defaultShareConfig.desc,
      link: shareConfig.link || defaultShareConfig.link,
      success: shareConfig.success,
      cancel: shareConfig.cancel,
      fail: shareConfig.fail,
      complete: shareConfig.complete
    }
  }

  async getTicket() {
    let url = ua.isIOS ? getWechatRegisterURL()['url'] : window.location.href
    url = url.replace('http://localhost:8080', 'https://h5-test.globuyx.com/lottery/shop')
    console.log('url', url)
    const timestamp = Date.parse(new Date()) / 1000
    // const { data } = await wechat.getTicket(url)
    const sign = `jsapi_ticket=O3SMpm8bG7kJnF36aXbe82L0-hG-IyjeowYYQHwynoofgJU2PGECTqCZ7Eu5vUOc2zAtPiYiG7IJJzKt8yldAA&noncestr=Wm3WZYTPz0wzccnW&timestamp=${timestamp}&url=https://h5-test.globuyx.com/lottery/shop`
    let data = {
      err: 0,
      res: {
        appId: 'wxe7db33d6f8a4fc84',
        timestamp,
        nonceStr: 'Wm3WZYTPz0wzccnW',
        signature: sha1(sign)
      }
    }

    if (data.err === 0) {
      isGetTicket = true

      wx.config({
        debug: true,
        appId: data.res.appId,
        timestamp: data.res.timestamp,
        nonceStr: data.res.nonceStr,
        signature: data.res.signature,
        jsApiList
      })
    }
  }
}

export default Wechat
